import { inject, Directive } from '@angular/core';

import { APP_DIALOG_DATA } from '@/app/shared/components/ui/dialog/dialog';
import { AppDialogRef } from '@/app/shared/components/ui/dialog/dialog-ref';

@Directive()
export abstract class BaseDialogComponent<DialogData, DialogResult> {
  protected data: DialogData = inject(APP_DIALOG_DATA);

  protected dialogRef: AppDialogRef<BaseDialogComponent<DialogData, DialogResult>, DialogResult> =
    inject<AppDialogRef<BaseDialogComponent<DialogData, DialogResult>, DialogResult>>(AppDialogRef);

  closeModal() {
    this.dialogRef.cancel();
  }
}
